import CreateNavService from '@/service/createNavService'
import HistoryColuumnService from '@/service/historyColumnService'
export default class GetColumnInformation {
  constructor (module, url1, url2) {
    this.module = module
    this.columnUrl = url1
    this.documentUrl = url2
  }

  getColumn () {
    let me = this
    let params = me.module.$route.params
    if (params.propType) {
      me.module.searchShow = true
      let columnUrl = me.columnUrl.replace('{columnId}', params.column)
      let documentUrl = me.documentUrl.replace('{id}', params.column)
      let getColumnsService = new CreateNavService(me.module, columnUrl, documentUrl, {propType: params.propType, page: 1, pageSize: 20, keyword: me.module.keyword})
      getColumnsService.getDocumentsData()
    } else {
      me.module.searchShow = false
      let url = me.columnUrl.replace('{columnId}', params.column)
      let getColumnsService = new HistoryColuumnService(me.module, url)
      getColumnsService.checkColumnDetail()
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/getColumnInfo.js